module.exports = __webpack_public_path__ + "img/22.1a72b81b.png";